import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { apiCallWrapper } from "../../api/api.util";
import { HasIdOrExternalValueOrExternalIdOrServiceName } from "../../api/generic.api";
import { WorkflowStepApi } from "../../api/workflow/workflow-step.api";
import { IQueryFilter } from "../../model/query.filter.class";
import { WorkflowStep } from "../../model/workflow/workflow-step.model";
import { BaseService } from "../base.service";
import { ToastService } from "../toast.service";

@Injectable({
  providedIn: "root",
})
export class WorkflowStepService extends BaseService {
  private _workflowSteps: WorkflowStep[] = [];

  constructor(
    private workflowStepApi: WorkflowStepApi,
    private toastService: ToastService,
  ) {
    super();
  }

  async getWorkflowSteps(): Promise<WorkflowStep[]> {
    if (this._workflowSteps.length === 0) {
      await this._loadSteps();
    }
    return this._workflowSteps;
  }

  /**
   * Load all workflow steps
   */
  private async _loadSteps(): Promise<void> {
    try {
      const queryFilter: IQueryFilter = new IQueryFilter();
      queryFilter.limit = 500;

      const data = await lastValueFrom(
        apiCallWrapper(this.workflowStepApi.list(queryFilter), {
          toastService: this.toastService,
          action: "Fetching workflow steps",
        }),
      );

      const workflowSteps = this.inflateModel<
        WorkflowStep,
        WorkflowStep & HasIdOrExternalValueOrExternalIdOrServiceName<string>
      >(WorkflowStep, data);

      if (workflowSteps) {
        this._workflowSteps = workflowSteps.rows;
      }
    } catch (error) {
      throw error;
    }
  }
}
